import { AppRegistry, Platform } from 'react-native';
import React from 'react';
import App from './App';  // Ensure App is the correct path to your App component
import { LoadingProvider } from './LoadingContext';
// Prostay design-system tokens — global CSS variables only, zero visual impact
// on legacy screens. Imported before app CSS so variables are available everywhere.
import './ui/tokens/tokens.css';
import './css/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// Design-system baseline reset, SCOPED under `.ps-scope`. Imported last so it can
// neutralize legacy global rules on redesigned surfaces without touching others.
import './ui/foundations/foundations.css';
// Shared dialog/popup retone — imported last so it unifies the legacy popups.
import './css/dialogs.css';

// Register the app for both mobile and web
const TableView = () => (
  <LoadingProvider>
    <App />
  </LoadingProvider>
);

AppRegistry.registerComponent("TableView", () => TableView);

if (Platform.OS === 'web') {
  const rootTag = document.getElementById('root') || document.createElement('div');
  AppRegistry.runApplication("TableView", { initialProps: {}, rootTag });
}
